export function createTenantBrandingClient(transport) {
    return {
        /**
         * List current tenant themes
         *
         * Requires scope: tenant-branding:read
         */
        getThemes(options) {
            return transport.request({
                method: "GET",
                path: "/v1/themes",
                options,
            });
        },
        /**
         * Get current theme
         *
         * Requires scope: tenant-branding:read
         */
        getThemes2(key, options) {
            return transport.request({
                method: "GET",
                path: `/v1/themes/${encodeURIComponent(key)}`,
                options,
            });
        },
        /**
         * Create a new immutable theme version
         *
         * Requires scope: tenant-branding:write
         */
        putThemes(key, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/themes/${encodeURIComponent(key)}`,
                body,
                options,
            });
        },
        /**
         * Get an immutable theme version
         *
         * Requires scope: tenant-branding:read
         */
        getThemesVersions(key, version, options) {
            return transport.request({
                method: "GET",
                path: `/v1/themes/${encodeURIComponent(key)}/versions/${encodeURIComponent(version)}`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=tenant-branding.js.map